"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_E2E = void 0;
exports.COOKIE_E2E = 'e2eAccessToken';
//# sourceMappingURL=constants.js.map